import { Checkbox, Table, UnstyledButton } from '@mantine/core';
import { Link } from 'react-router-dom';
import { RecordLabel } from '../Diff/RecordLabel.js';
import { LoadMoreFooter } from './LoadMoreFooter.js';
import type { Paging } from './types.js';

/** A sticky body cell; pair it with `className="rgs-sticky-cell"`, which paints it (and its hover tint) — see globals.css. */
export const stickyBody = (left: number): React.CSSProperties => ({
    position: 'sticky',
    left,
    zIndex: 1,
});

/** The grids' own leading checkbox cell — sticky at the left edge, both grids alike. */
export const SelectCell = ({
    ariaLabel,
    checked,
    onChange,
}: {
    ariaLabel: string;
    checked: boolean;
    onChange: () => void;
}) => (
    <Table.Td className="rgs-sticky-cell" style={stickyBody(0)}>
        <Checkbox aria-label={ariaLabel} checked={checked} onChange={onChange} />
    </Table.Td>
);

/** The grids' own key cell: a sticky, stacked `RecordLabel` that is the whole click target to the row's editor. */
export const NameCell = ({
    to,
    ariaLabel,
    title,
    entityKey,
    maw = 260,
}: {
    to: string;
    ariaLabel: string;
    title: string | null | undefined;
    entityKey: string;
    maw?: number;
}) => (
    <Table.Td className="rgs-sticky-cell" style={stickyBody(40)}>
        {/* The whole cell is the link, so it is not a 16px target. */}
        <UnstyledButton component={Link} to={to} aria-label={ariaLabel} style={{ display: 'block', cursor: 'pointer' }}>
            <RecordLabel layout="stacked" title={title} entityKey={entityKey} maw={maw} />
        </UnstyledButton>
    </Table.Td>
);

/** The grids' own footer row: `LoadMoreFooter`, sticky under the key column, spanning the rest. */
export const MatrixFooterRow = ({ colSpan, shown, paging }: { colSpan: number; shown: number; paging: Paging }) => (
    <Table.Tr>
        <Table.Td colSpan={colSpan} className="rgs-sticky-cell" style={stickyBody(0)}>
            <LoadMoreFooter
                shown={shown}
                total={paging.total}
                filtered={paging.filtered}
                hasMore={paging.hasMore}
                isLoadingMore={paging.isLoadingMore}
                onLoadMore={paging.onLoadMore}
            />
        </Table.Td>
    </Table.Tr>
);
